import { connect } from "react-redux";
import _ from "underscore";

var CurrentUser = require("lib/account/CurrentUser");
var WritingActions = require("lib/actions/WritingActions");
var ScoringToolTip = require("components/data/graphs/ScoringToolTip")
var DataRouting = require("lib/routing/DataRouting");
var DisplayToggleControl = require("components/utility/DisplayToggleControl");
var Spinner = require("components/utility/Spinner");
var {formatTimestamp} = require("components/data/graphs/GraphUtility")
const QUIZ_VIEW = 'quiz-view'
const ANSWER_VIEW = 'answer-view'

const PER_PAGE = 25

require('data/graphs/scoring_graph')
@connect(
	(state, props) => ({
	}),
	(dispatch, props) => {
        var fetchAnswers = (ids,pageNum)=> {
            return dispatch(WritingActions.fetchAnswers({
                conditions: { userIDs: [ids],draft: false },
                filters : {page: pageNum, per_page: PER_PAGE},
                embeds: ["answer.evaluation", "evaluation.score_details"],
                cache: false,
            }));
        }

        var fetchQuizzes = (ids, pageNum) => {
            return dispatch(WritingActions.fetchQuizzes({
                conditions: { userIDs: [ids],draft: false },
                filters : {page: pageNum, per_page: PER_PAGE},
                embeds: ["quiz.evaluation", "evaluation.score_details"],
                cache: false,
            }));
        }

        return {
            fetchQuizzes,
            fetchAnswers,
        }
    }
)
class IndividualScoringGraph extends React.Component {
	constructor(props) {
		super();
		autobind(this);

        var initialView = props.view || QUIZ_VIEW
        this.state = {
            view: initialView,
            answers: [],
            quizzes: [],
            loadingWork: false,
            loadedDependencies: false
        }
    }

    // function called recursively to fetch all data
    fetchData(pageNum){
        if (!pageNum){ pageNum = 1}
        
        // if the first request, set loading to true
        if ( pageNum == 1 ) {this.setState({loadingWork: true})}
        
        var studentIDs = _.pluck(this.props.students, 'id')

        if (this.state.view == QUIZ_VIEW){
            this.props.fetchQuizzes(studentIDs, pageNum).then(res=>{
                // add evaluations straight to the quizzes, so they are easier to work w
                var quizzesWithEvals = []
                for (var i = 0; i < res.quizzes.length; i++){
                    var quiz = res.quizzes[i]
                    quiz.evaluation = res.evaluations[i]
                    quizzesWithEvals.push(quiz)
                }
                var quizzes = [...this.state.quizzes].concat(quizzesWithEvals)

                // add those quizzes to data
                this.setState({quizzes: quizzes})
                
                if (res.quizzes.length == PER_PAGE) { 
                    this.fetchData(pageNum + 1)
                } else {
                    this.setState({loadingWork: false})
                }
            })
        
        } else if (this.state.view == ANSWER_VIEW){
            this.props.fetchAnswers(studentIDs, pageNum).then(res=>{
                // add evaluations straight to the quizzes, so they are easier to work w
                var answersWithEvals = []
                for (var i = 0; i < res.answers.length; i++){
                    var answer = res.answers[i]
                    answer.evaluation = res.evaluations[i]
                    answersWithEvals.push(answer)
                }
                var answers = [...this.state.answers].concat(answersWithEvals)

                // add those answers to data
                this.setState({answers: answers})
                
                if (res.answers.length == PER_PAGE) { 
                    this.fetchData(pageNum + 1)
                } else {
                    this.setState({loadingWork: false})
                }          
            })
        }

    }

    createTicks(){
        var dates = []
        var now = new Date()
        var startMonth = CurrentUser.get().prefs.school_year_start_month || 8
        if (now.getMonth() >= startMonth) {
			var startYear = now.getFullYear()
		} else {
			var startYear = now.getFullYear() - 1
		}
        var yearStartDate = new Date(startYear,startMonth)
        
        // want to know how many months we are into the year, to add filler.
        var monthDifference = (now.getFullYear()*12 + now.getMonth()) - (yearStartDate.getFullYear()*12 + yearStartDate.getMonth())
        
        
        // if less than 3 months into the school year, add ticks for the first three months
        if (monthDifference < 3){
            dates.push(new Date(now.getFullYear(), startMonth))
            dates.push(new Date(now.getFullYear(), startMonth + 1))
            dates.push(new Date(now.getFullYear(), startMonth + 2))
        } else {
            for(var monthNum = 0; monthNum <= monthDifference; monthNum ++){
                dates.push(new Date(startYear, startMonth + monthNum))
            }
        }
        //now that we have list of months, convert to timestamps.
        return _.map(dates, (time=>(time.getTime())))
    }

    // create ratio for the score of the answer/quiz.
    convertedScore(ratio) {
        const SCORE_DISPLAY_CAP = 4
		var score = ratio * SCORE_DISPLAY_CAP
		// Round down to nearest 0.5
		score = Math.floor(score * 2) / 2;
		return score;
	}

    // creates formatted data
    createData(){
        if (this.state.view == QUIZ_VIEW) {
            var workType = 'quizzes'
        } else if (this.state.view == ANSWER_VIEW){
            workType = 'answers'
        }

        var failing = []
        var passing = []
        var thresholdRatio = CurrentUser.get().prefs.passing_threshold || .75
        var threshold = this.convertedScore(thresholdRatio)
        for (var i = 0; i< this.state[workType].length; i++){
            var work = this.state[workType][i]
            var scatterPoint = {timeStamp: [], score: []}
            if (work.evaluation){
                var score = this.convertedScore(work.evaluation['ratio'])
                scatterPoint.score.push(score)
                scatterPoint.timeStamp.push(Date.parse(work.evaluation['created_at']))
                if (score >= threshold){
                    passing.push(scatterPoint)
                } else {
                    failing.push(scatterPoint)
                }
            }
        }
        return {'failing': failing, 'passing': passing}
    }
    

    handlePointClick(pointInfo){
        if (this.state.view == QUIZ_VIEW){
            var view = 'quizzes'
        } else {
            var view = 'answers'
        }

        var completedAt = new Date(pointInfo.payload.timeStamp[0])
        // find the quiz that was clicked on
        var selectedWork = _.find(this.state[[view]], (data)=>{
            return _.isEqual(new Date(data.evaluation.created_at), completedAt)
        })
        
        // need to get query end because datapage url routing requires dates. The date is just a 1 day range.
        // also need to increment by a month, bc js indexes months from 0
        var queryStart = new Date(completedAt.getFullYear(), completedAt.getMonth() + 1, completedAt.getDate())
        var queryEnd = new Date(completedAt.getFullYear(), completedAt.getMonth() + 1, completedAt.getDate() + 1)
        var dateStrings = _.map([queryStart, queryEnd], (date)=>(date.getFullYear() + "-" + date.getMonth() + "-" +  date.getDate()))
        
        var query = {
            userIDs: [selectedWork.user_id],
            studentList: this.props.activeStudentList.id.toString(),
            startDate: dateStrings[0],
            endDate: dateStrings[1]
        }

        if (this.state.view == QUIZ_VIEW) {
            query.subjectType = 'Quizzes'
            query.quizID = selectedWork.id
        } else {
            query.subjectType = "Writing"
            query.answerID = selectedWork.id
        }
        
        var path = DataRouting.getPath(query, "nope")
        $wr.redirect(path)
    }


    createIndividualScoringGraph(){
        var data = this.createData()
        if (this.state.view == QUIZ_VIEW){
            var passingThreshold = this.convertedScore(CurrentUser.get().prefs.passing_threshold) || 3
            var thresholdLine = <Recharts.ReferenceLine y={passingThreshold} stroke="red" strokeDasharray="3 3" />
            var toolTipData = this.state.quizzes
            return(
                <Recharts.ScatterChart width={730} height={300}>
                    <Recharts.CartesianGrid strokeDasharray="3 3" />
                    <Recharts.XAxis dataKey="timeStamp" tickFormatter={formatTimestamp} ticks={this.createTicks()} domain={["auto", "auto"]} name="Time" type='number'/>
                    <Recharts.YAxis dataKey="score" name="Scores" domain={[0,4]}/>
                    <Recharts.Scatter name="data" data={data['failing']} fill="#ff7979" onClick={this.handlePointClick}/>
                    <Recharts.Scatter name="data" data={data['passing']} fill="#aae58c" onClick={this.handlePointClick}/>
                    <Recharts.Tooltip content={<ScoringToolTip data={toolTipData}/>} />
                    {thresholdLine}
                </Recharts.ScatterChart>
            )
        } else if (this.state.view == ANSWER_VIEW) {
            var toolTipData = _.where(this.state.answers, (answer)=>{answer.evaluation})
            var passingThreshold = this.convertedScore(CurrentUser.get().prefs.passing_threshold) || 3
            var thresholdLine = <Recharts.ReferenceLine y={passingThreshold} stroke="red" strokeDasharray="3 3" />
            return(
                <Recharts.ScatterChart width={730} height={300}>
                    <Recharts.CartesianGrid strokeDasharray="3 3" />
                    <Recharts.XAxis dataKey="timeStamp" tickFormatter={formatTimestamp} ticks={this.createTicks()} domain={["auto", "auto"]} name="Time" type='number'/>
                    <Recharts.YAxis dataKey="score" name="Scores" domain={[0,4]}/>
                    <Recharts.Scatter name="data" data={data['failing']} fill="#ff7979" onClick={this.handlePointClick}/>
                    <Recharts.Scatter name="data" data={data['passing']} fill="#aae58c" onClick={this.handlePointClick}/>
                    <Recharts.Tooltip content={<ScoringToolTip data={toolTipData}/>} />
                    {thresholdLine}
                </Recharts.ScatterChart>
            )
        }
    }

    onViewChange(view) {
		if (view != this.state.view) {
            // fetch data next
            this.setState({ view: view });
		}
	}

    renderToggle(){
        var toggleOptions = [{ key: QUIZ_VIEW, text: "Quizzes" }, { key: ANSWER_VIEW, text: "Answers" }];

        var toggleDisplay = (
            <DisplayToggleControl options={ toggleOptions }
                onChange={ this.onViewChange } className="hideOnPrint"
                activeOptionKey={ this.state.view } />
        )
        return toggleDisplay
    }

    render(){
        if (!this.state.loadedDependencies || this.state.loadingWork) {
            var graph = <Spinner className='spinner'/>
        } else {
            var graph = this.createIndividualScoringGraph()
        }
        
        return (
            <div className='ScoringGraph'>
                {graph}
            </div>
        )
    }

    componentDidMount(){
        $wr.loadScript("/dependencies/recharts.min.js", "Recharts", () => {
			this.setState({ loadedDependencies: true });
		});
        this.fetchData()
    }

    componentDidUpdate(prevProps, prevState) {
        // if new set of students are passed in, need to fetch more data
        if (!_.isEqual(this.props.students, prevProps.students)) {
            this.setState({quizzes: [], answers: []})
            this.fetchData();
        } else if (this.state.view != prevState.view){
            this.fetchData()
        }
        
    }
}


IndividualScoringGraph.propTypes = PageStrictPropTypes({
    activeStudentList: PropTypes.object,
    students: PropTypes.array,
    view: PropTypes.string
});

module.exports = IndividualScoringGraph


// WEBPACK FOOTER //
// ./modules/components/data/graphs/IndividualScoringGraph.js